import logo from "../../../../logo.png";

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 py-16 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-4">
          <div className="flex items-center gap-3">
            <img src={logo} alt="Association Integrity logo" className="h-10 w-auto object-contain flex-shrink-0" />
            <div className="flex flex-col leading-tight">
              <span className="font-heading text-lg font-semibold text-background-50">
                Association Integrity
              </span>
              <span className="text-[11px] uppercase tracking-[0.18em] text-background-200">
                South Florida Website Compliance
              </span>
            </div>
          </div>
          <p className="mt-6 text-sm leading-relaxed text-background-200 max-w-sm">
            The compliance partner for HOAs, condos and 55+ communities across Miami-Dade, Broward,
            Palm Beach and every county along the coast. Discreet, documented, done right.
          </p>
        </div>

        <div className="lg:col-span-2">
          <h4 className="font-heading text-background-50 text-sm font-semibold mb-4 tracking-wide">
            <a href="#services" className="cursor-pointer">
              Services
            </a>
          </h4>
          <ul className="space-y-2 text-sm">
            {[
              "Statutory Audit",
              "ADA / WCAG Remediation",
              "Compliant Website Build",
              "HOPA 55+ Toolkit",
              "Managed Hosting",
              "Cyber and Privacy",
            ].map((l) => (
              <li key={l}>
                <a
                  href="#services"
                  className="text-background-200 hover:text-background-50 cursor-pointer whitespace-nowrap"
                >
                  {l}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-3">
          <h4 className="font-heading text-background-50 text-sm font-semibold mb-4 tracking-wide">
            <a href="#audience" className="cursor-pointer">
              Communities we serve
            </a>
          </h4>
          <ul className="space-y-2 text-sm">
            {[
              "HOAs (100+ parcels)",
              "Condominium associations",
              "Cooperatives",
              "55+ / HOPA communities",
              "Master-planned communities",
              "Property management companies",
            ].map((l) => (
              <li key={l}>
                <a
                  href="#audience"
                  className="text-background-200 hover:text-background-50 cursor-pointer"
                >
                  {l}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-3">
          <h4 className="font-heading text-background-50 text-sm font-semibold mb-4 tracking-wide">
            <a href="#contact" className="cursor-pointer">
              Contact
            </a>
          </h4>
          <ul className="space-y-3 text-sm text-background-200">
            <li className="flex items-start gap-2">
              <i className="ri-map-pin-line mt-0.5 text-accent-300" />
              Fort Lauderdale, FL
            </li>
            <li className="flex items-start gap-2">
              <i className="ri-phone-line mt-0.5 text-accent-300" />
              <a href="tel:+19544444747" className="hover:text-background-50 cursor-pointer">
                (954) 444-4747
              </a>
            </li>
            <li className="flex items-start gap-2">
              <i className="ri-mail-line mt-0.5 text-accent-300" />
              <a
                href="mailto:boards@associationintegrity.com"
                rel="nofollow"
                className="hover:text-background-50 cursor-pointer break-all"
              >
                boards@associationintegrity.com
              </a>
            </li>
            <li className="flex items-start gap-2">
              <i className="ri-time-line mt-0.5 text-accent-300" />
              Mon–Fri · 8:30a – 6:00p ET
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-background-50/10">
        <div className="max-w-[1280px] mx-auto px-6 md:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-200">
          <p>
            © {new Date().getFullYear()} Association Integrity, LLC. All rights reserved. Licensed
            website compliance consultancy · South Florida.
          </p>
          <div className="flex items-center gap-5">
            <a href="#faq" className="hover:text-background-50 cursor-pointer whitespace-nowrap">
              Privacy
            </a>
            <a href="#faq" className="hover:text-background-50 cursor-pointer whitespace-nowrap">
              Accessibility statement
            </a>
            <a href="#faq" className="hover:text-background-50 cursor-pointer whitespace-nowrap">
              Terms
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}